window.addEventListener("pplrAppInitiated", function () {
  const lastSegment = location.pathname.split("/").pop();

  // --- Debounce Utility ---
  function debounce(func, wait) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () { func.apply(context, args); }, wait);
    };
  }

  // --- State Mappings ---
  const STATE_MAPPINGS_DE = {
    "Baden Württemberg": ["AA","BAD","BB","BC","BCH","BH","BK","BL","BÜS","BWL","CR","CW","DS","EM","ES","FDS","FN","FR","GD","GP","HCH","HD","HDH","HN","HOR","KA","KEL","KN","KÜN","LB","LEO","LÖ","LR","MA","MGH","MOS","MÜL","NEU","NT","OG","ÖHR","PF","RA","RT","RV","RW","S","SÄK","SHA","SIG","SNH","STO","TBB","TU","TÜ","TUT","UL","VAI","VS","WN","WOL","WT"],
    "Bayern": ["A","AB","AIB","AIC","ALZ","AM","AN","AÖ","AS","BA","MUC","BGD","BGL","BOG","BRK","BT","BUL","BYL","CHA","CO","DAH","DEG","DGF","DKB","DLG","DON","EBE","EBN","EBS","ED","EG","EI","ER","ERH","ESB","FDB","FEU","FFB","FO","FRG","FS","FÜ","FÜS","GAP","GEO","GRA","GRI","GUN","GZ","HAB","HAS","HEB","HIP","HO","HOH","HÖS","ILL","IN","KC","KE","KEH","KEM","KF","KG","KÖN","KÖZ","KRU","KT","KU","LA","LAN","LAU","LF","LI","LIF","LL","M","MAI","MAK","MAL","MB","MET","MIL","MM","MN","MOD","MSP","MÜ","MÜB","N","NAB","NAI","ND","NEA","NEC","NEN","NES","NEW","NM","NÖ","NU","OA","OAL","OBB","OCH","OVI","PA","PAF","PAN","PAR","PEG","R","REG","REH","REI","RH","RID","RO","ROD","ROL","ROT","SAD","SAN","SC","SEF","SEL","SMÜ","SOB","SOG","SR","STA","SUL","SW","TIR","TÖL","TS","UFF","VIB","VIT","VOH","WEN","WM","WOR","WS","WÜ","WUG","WÜM","WUN"],
    "Berlin": ["B"],
    "Hamburg": ["HH"],
    "Brandenburg": ["ANG","BAR","BBL","BEL","BER","BRB","BSK","CA","CB","EE","EH","EW","FF","FI","FOR","FRW","FW","GUB","HVL","JB","KW","KY","LC","LDS","LIB","LN","LOS","LUK","MOL","NAU","NP","OHV","OPR","OSL","P","PM","PR","PZ","RN","SDT","SEE","SFB","SPB","SPN","SRB","TF","TP","UM","WER","WK"],
    "Hessen": ["BID","BÜD","DA","DI","DIL","ERB","ESW","F","FB","FD","FKB","FZ","GG","GI","GN","HEF","HEL","HG","HOG","HP","HR","HU","KB","KS","LDK","LM","MEG","MKK","MR","MTK","OF","ROF","RÜD","SLÜ","SWA","USI","VB","WA","WEL","WI","WIZ","WOH","WZ","ZIG"],
    "Mecklenburg Vorpommern": ["ANK","AT","BÜZ","DBR","DM","GDB","GMN","GÜ","GVM","GW","HGN","HGW","HRO","HST","HWI","LBZ","LRO","LUP","LWL","MC","MSE","MST","MÜR","MVL","NB","NVP","NWM","NZ","OVP","PCH","PW","RDG","RM","ROS","RÜG","SBG","SN","STB","STE","TET","UEM","VG","VR","WIS","WLG","WRN"],
    "Niedersachsen": ["ALF","AUR","BRA","BRL","BRV","BSB","BS","CE","CLP","CLZ","CUX","DAN","DEL","DH","DUD","EIN","EL","EMD","FRI","GAN","GF","GÖ","GS","H","HE","HI","HK","HM","HMÜ","HOL","LER","LG","MEL","NI","NL","NOH","NOM","NOR","OHA","OHZ","OL","OS","PE","RI","ROW","SHG","STD","SZ","UE","VEC","VER","WF","WHV","WL","WOB","WST","WTL","WTM"],
    "Nordrhein Westfalen": ["AC","AH","BE","BF","BI","BLB","BM","BN","BO","BOH","BOR","BOT","BÜR","CAS","COE","D","DIN","DN","DO","DU","E","EN","ERK","EU","GE","GEL","GK","GL","GLA","GM","GT","GV","HA","HAM","HER","HF","HS","HSK","HX","JÜL","K","KK","KLE","KR","LEV","LH","LIP","LK","LP","LÜN","ME","MG","MH","MI","MK","MO","MON","MS","NE","NRW","OB","OE","OP","PB","RE","RS","SG","SI","SLE","SO","ST","SU","TE","UN","VIE","W","WAF","WAN","WAR","WAT","WES","WIT"],
    "Rheinland Pfalz": ["AK","AW","AZ","ZEL","BIN","BIR","BIT","BKS","COC","DAU","DIZ","DÜW","EMS","FT","GER","GOA","GOH","KH","KIB","KL","KO","KUS","LD","LU","MY","MYK","MZ","NR","NW","PRÜ","PS","ROK","RP","RPL","SAB","SIM","SP","SÜW","TR","WIL","WO","WW","ZW"],
    "Saarland": ["HOM","IGB","MZG","NK","OTW","SAL","SB","SLS","VK","WND"],
    "Sachsen": ["AE","ANA","ASZ","AU","BED","BIW","BNA","BZ","C","DD","DL","DW","DZ","EB","ERZ","FG","FLÖ","FTL","GC","GHA","GR","GRH","GRM","HC","HOT","HY","KM","L","LÖB","LSN","MAB","MEI","MEK","MTL","MW","NOL","NY","OVL","OZ","PIR","PL","RC","RG","RIE","RL","SEB","STL","SZB","TDO","TG","TO","V","WDA","WOS","WSW","WUR","Z","ZI","ZP"],
    "Sachsen Anhalt": ["ABI","ASL","AZE","BBG","BLK","BÖ","BRG","BTF","DE","EIL","GA","GHC","GNT","HAL","HBS","HDL","HET","HHM","HV","HZ","JE","JL","KLZ","KÖT","LSA","MD","MER","ML","MQ","MSH","NEB","NMB","OBG","OC","OK","QFT","QLB","RSL","SAW","SBK","SDL","SFT","SGH","SK","SLK","WB","WMS","WR","WSF","WZL","ZE","ZZ"],
    "Bremen": ["HB"],
    "Schleswig Holstein": ["ECK","FL","HEI","HL","IZ","KI","MED","NF","NMS","OD","OH","PI","PLÖ","RD","RZ","SE","SH","SL"],
    "Thüringen": ["ABG","AP","APD","ARN","ART","EA","EF","EIC","EIS","G","GRZ","GTH","HBN","HIG","IK","IL","J","KYF","LBS","LSZ","MGN","MHL","NDH","NH","PN","RU","SCZ","SDH","SHK","SHL","SLF","SLN","SLZ","SM","SOK","SÖM","SON","SRO","THL","UH","WAK","WBS","WE","ZR"]
  };

  const STATE_MAPPINGS_AT = {
    "Burgenland": ["E","EU","GS","JE","MA","ND","OP","OW"],
    "Kärnten": ["FE","HE","K","KL","SP","SV","VI","VK","VL","WO"],
    "Niederösterreich": ["AM","BL","BN","GD","GF","HL","HO","KG","KO","KR","KS","LF","MD","ME","MI","NK","P","PL","SB","SW","TU","WB","WN","WT","WY","ZT"],
    "Oberösterreich": ["BR","EF","FR","GM","GR","KI","L","LL","PE","RI","RO","SD","SE","SR","UU","VB","WE","WL"],
    "Salzburg": ["HA","JO","S","SL","TA","ZE"],
    "Steiermark": ["BM","DL","G","GB","GU","HF","LB","LE","LI","LN","MT","MU","SO","VO","WZ"],
    "Tirol": ["I","IL","IM","KB","KU","LA","LZ","RE","SZ"],
    "Vorarlberg": ["B","BZ","DO","FK"],
    "Wien": ["W"]
  };

  // --- Product Configurations ---
  var PRODUCTS = [
    {
      handles: ["kennzeichen-schlusselanhanger-mini-nummernschild-metall"],
      stateMappings: STATE_MAPPINGS_DE,
      fallbackState: "Baden Württemberg",
      config: {
        first: "pplr-stadt", second: "pplr-buchstaben", third: "pplr-zahlen",
        logo1: "pplr-bundesland", logo2: "pplr-tv"
      },
      frontadjust: [486, 225, 670, 24.74, 2],
      backadjust: [486, 480, 670, 24.74, 14],
      renderFactor: 0.75,
      logoSize: [60, 60],
      logoOffsetY: -50,
      letterSpacing8: "-5px",
      letterSpacing7: "-2px",
      hasBack: true,
      requiresKennzeichenCheck: false
    },
    {
      handles: ["fahrzeugschein-huelle", "kuhlschrankmagnet-aus-metall-kennzeichen-deutschland-individuell-personalisierbar", "kennzeichen-schlusselanhanger-mit-flaschenoffner-mini-nummernschild-metall"],
      stateMappings: STATE_MAPPINGS_DE,
      fallbackState: "Baden Württemberg",
      config: {
        first: "pplr-stadt", second: "pplr-buchstaben", third: "pplr-zahlen",
        logo1: "pplr-bundesland", logo2: "pplr-tv"
      },
      frontadjust: [306, 300, 670, 24.74, 2],
      backadjust: null,
      renderFactor: 0.75,
      logoSize: [60, 60],
      logoOffsetY: -50,
      letterSpacing8: "-5px",
      letterSpacing7: "-2px",
      hasBack: false,
      requiresKennzeichenCheck: true
    },
    {
      handles: ["osterreich-kennzeichen-schlusselanhanger-mini-nummernschild-metall"],
      stateMappings: STATE_MAPPINGS_AT,
      fallbackState: "Wien",
      config: {
        first: "pplr-stadt", second: "pplr-buchstaben", third: "pplr-zahlen",
        logo1: "pplr-bundesland", logo2: "pplr-tv"
      },
      frontadjust: [486, 225, 670, 24.74, 2],
      backadjust: [486, 480, 670, 24.74, 14],
      renderFactor: 0.72,
      logoSize: [60, 90],
      logoOffsetY: -90,
      letterSpacing8: "-7px",
      letterSpacing7: "-4px",
      hasBack: true,
      requiresKennzeichenCheck: false
    },
    {
      handles: ["fahrzeugschein-hulle-mit-kennzeichen-osterreich"],
      stateMappings: STATE_MAPPINGS_AT,
      fallbackState: "Wien",
      config: {
        first: "pplr-stadt", second: "pplr-buchstaben", third: "pplr-zahlen",
        logo1: "pplr-bundesland", logo2: "pplr-tv"
      },
      frontadjust: [306, 300, 670, 24.74, 2],
      backadjust: null,
      renderFactor: 0.72,
      logoSize: [60, 90],
      logoOffsetY: -90,
      letterSpacing8: "-7px",
      letterSpacing7: "-4px",
      hasBack: false,
      requiresKennzeichenCheck: true
    }
  ];

  // --- Find matching product ---
  var product = PRODUCTS.find(function (p) {
    return p.handles.some(function (h) {
      return lastSegment === h || (lastSegment && lastSegment.indexOf(h + "?") !== -1);
    });
  });

  if (!product) return;

  var cfg = product.config;

  // --- Shared: Update state field based on city input ---
  function updateStateField(cityValue) {
    var stateField = document.querySelector("." + cfg.logo1 + " .pplr-selecter-selected");
    var hiddenInput = document.querySelector("." + cfg.logo1 + " input[data_name='Bundesland']");
    if (!stateField || !hiddenInput) return;

    var newState = Object.keys(product.stateMappings).find(function (state) {
      return product.stateMappings[state].indexOf(cityValue.toUpperCase()) !== -1;
    }) || product.fallbackState;

    var imgElement = stateField.querySelector("img");
    if (imgElement) {
      imgElement.setAttribute("src",
        "https://cdn-zeptoapps.com/product-personalizer/images/kennzeichen-dev.myshopify.com/" +
        newState.toLowerCase().replace(/ /g, "-") + ".jpg?v=12310"
      );
    }

    var ppdataElement = stateField.querySelector(".ppdata");
    if (ppdataElement) {
      ppdataElement.textContent = newState;
    }

    hiddenInput.value = newState;

    var matchingOption = document.querySelector("." + cfg.logo1 + " .pplr-swatch-element[data-val='" + newState + "']");
    if (matchingOption) {
      matchingOption.click();
    }
  }

  // --- Shared: City field listener with debounce ---
  var debouncedUpdate = debounce(updateStateField, 300);
  var currentHandler = null;

  function addCityFieldListener() {
    var cityField = document.querySelector("." + cfg.first + " .pplr_text");
    if (!cityField) return;

    if (currentHandler) {
      cityField.removeEventListener("input", currentHandler);
    }
    currentHandler = function (event) {
      debouncedUpdate(event.target.value);
    };
    cityField.addEventListener("input", currentHandler);
  }

  // --- Shared: MutationObserver setup ---
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].type === "childList") {
        addCityFieldListener();
        return;
      }
    }
  });

  var personalizerContainer = document.querySelector(".pplr-main-container");
  observer.observe(personalizerContainer || document.body, {
    childList: true,
    subtree: true,
    attributes: false
  });

  document.addEventListener("DOMContentLoaded", addCityFieldListener);
  setTimeout(addCityFieldListener, 1000);

  document.addEventListener("click", function (event) {
    if (event.target.matches(".popup-open-button")) {
      setTimeout(function () {
        observer.disconnect();
        var container = document.querySelector(".pplr-main-container");
        observer.observe(container || document.body, {
          childList: true,
          subtree: true,
          attributes: false
        });
        addCityFieldListener();
      }, 500);
    }
  });

  // --- Shared: Canvas rendering ---
  function generateLicenseKey(originalCanvas, fn) {
    var firstField = document.querySelector("." + cfg.first + " .pplr_text");
    if (!firstField) {
      if(fn){
        fn();
      }
      return;
    };

    if (product.requiresKennzeichenCheck) {
      var rueckseiteEl = document.querySelector('[name="properties[Rückseite]"]');
      var designEl = document.querySelector('[name="properties[Design]"]');
      var rueckseiteValue = rueckseiteEl ? rueckseiteEl.value : "";
      var designValue = designEl ? designEl.value : "";

      if (rueckseiteValue !== "Kennzeichen" && designValue !== "Kennzeichen") {
        // window.pplr_canvas_render_final(pplr_svg, originalCanvas, 1, );
        if(fn){
          fn();
        }
        return;
      }
    }

    var first = firstField.value.toUpperCase();
    var secondField = document.querySelector("." + cfg.second + " .pplr_text");
    var thirdField = document.querySelector("." + cfg.third + " .pplr_text");
    var second = secondField ? secondField.value.toUpperCase() : "";
    var third = thirdField ? thirdField.value.toUpperCase() : "";
    var totalChar = first.length + second.length + third.length;

    var canvas = originalCanvas;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(originalCanvas, 0, 0);

    var fillColor = firstField.getAttribute("data-color") || firstField.dataset.color;

    function generate(adjustments) {
      var canwidth = canvas.width;
      var canheight = canvas.height;
      var m_ = _PP[_CM + adjustments[4]].split(",");
      var ypos = (m_[3] * canheight) / 100;
      var height = (m_[14] * canheight) / 100;
      var pss = m_[1];
      var fSize = pss * 0.75 * (canheight / 500);
      var expname = m_[0].split("/").pop().replace(".ttf", "");
      var fName = expname.replace("_", "");

      ctx.font = fSize + "pt " + fName;
      ctx.fillStyle = fillColor;

      var width = ctx.measureText(first).width;
      var textHeight =
        ctx.measureText("WWWMyf").actualBoundingBoxAscent +
        ctx.measureText("WWWMyf").actualBoundingBoxDescent;
      var imageObj = new Image();
      width += 10;

      imageObj.onload = function () {
        if (totalChar > 6) {
          fSize = (pss - (totalChar - 6) * 3) * product.renderFactor * (canheight / 500);
          if (totalChar === 8) {
            ctx.letterSpacing = product.letterSpacing8;
            if (p_isMobile) {
              fSize -= 7;
              height -= 1;
            }
          } else if (totalChar === 7) {
            ctx.letterSpacing = product.letterSpacing7;
          }
          ctx.font = fSize + "pt " + fName;
        }

        width += 65;
        width += ctx.measureText(second).width + 10;
        width += ctx.measureText(third).width + 10;

        var portionWidth = adjustments[2];
        var left = Math.ceil((portionWidth - width) / 2);
        var newWidth = adjustments[0] + left;
        var newHeight = ypos + height - (height - textHeight) / 2 - 2;

        if (totalChar === 8 && p_isMobile) {
          newHeight -= 7;
          newWidth += 4;
        }
        if (totalChar === 7 && p_isMobile) {
          newHeight -= 2;
          newWidth -= 2;
        }

        ctx.fillText(first, newWidth, newHeight);
        newWidth += ctx.measureText(first).width + 10;
        ctx.drawImage(imageObj, newWidth, newHeight + product.logoOffsetY, product.logoSize[0], product.logoSize[1]);

        var tvCheckbox = document.querySelector(".pplr-checkbox.pplr-tv-plakette-hinzufgen .pplrcheckbox");
        if (tvCheckbox && tvCheckbox.checked) {
          var anotherImg = new Image();
          anotherImg.onload = function () {
            ctx.drawImage(anotherImg, newWidth, newHeight - 110, product.logoSize[0], product.logoSize[1]);
            newWidth += 65;
            ctx.fillText(second, newWidth, newHeight);
            newWidth += ctx.measureText(second).width + 10;
            ctx.fillText(third, newWidth, newHeight);
            if (fn) fn();
          };
          var tvImg = document.querySelector("." + cfg.logo2 + " img");
          anotherImg.crossOrigin = "anonymous";
          anotherImg.src = tvImg ? tvImg.getAttribute("data-psrc") : "";
        } else {
          newWidth += 65;
          ctx.fillText(second, newWidth, newHeight);
          newWidth += ctx.measureText(second).width + 10;
          ctx.fillText(third, newWidth, newHeight);
          if (fn) fn();
        }
      };

      var logoImg = document.querySelector("." + cfg.logo1 + " img");
      imageObj.crossOrigin = "anonymous";
      imageObj.src = logoImg ? logoImg.getAttribute("data-psrc") : "";
    }

    generate(product.frontadjust);

    if (product.hasBack) {
      var rueckseiteEl = document.querySelector('[name="properties[Rückseite]"]');
      if (rueckseiteEl && rueckseiteEl.value === "Beide Seiten gleich") {
        generate(product.backadjust);
      }
    }
  }

  window.pplr_canvas_rendered = function (originalCanvas, fn) {
    var firstField = document.querySelector("." + cfg.first + " .pplr_text");
    var has_custom = false;
    Object.keys(pplr_values).map((key) => {
        const item = pplr_values[key];
        if(item[8] == "Stadt"){
            has_custom = true;
        }
    })
    if (firstField || has_custom) {
      generateLicenseKey(originalCanvas, fn);
    }else {
      fn();
    }
  };
});
